import {
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewChildren,
    Renderer2,
    Inject,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
    FormArray,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ProductoServicio, UnidadMedida } from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import { Observable, forkJoin } from 'rxjs';
import { Store } from '@ngrx/store';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import {
    AppState,
    selectOperacionState,
    selectUtilsState,
} from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SharedModule } from 'app/shared/shared.module';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface PeriodicElement {
    position: string;
    nombre: string;
    tasa: number;
    monto: number;
    typo: string;
}

export interface PeriodicElement2 {
    numero_Pedimento: number;
    position: number;
}

const datosTabla1: PeriodicElement[] = [];

const datosTabla2: PeriodicElement2[] = [];

@Component({
    selector: 'app-producto-add',
    templateUrl: './producto-add.component.html',
    styleUrls: ['./producto-add.component.scss'],
})
export class ProductoAddComponent implements OnInit {
    tasaa = new FormControl([Validators.pattern]);
    unidadMedida: UnidadMedida[] = [];
    filteredUnidadMedida: Observable<UnidadMedida[]>;
    getStateOperacion: Observable<any>;

    productoForm: FormGroup;
    randomElementIndex2: number;
    randomElementIndex1: number;

    options = [];
    filteredOptions: Observable<ProductoServicio[]>;
    myControl = new FormControl();
    myControlUnidadMedida = new FormControl();
    @ViewChild('datosTabla1') datosTabla1: MatTable<PeriodicElement>;
    @ViewChild('datosTabla2') datosTabla2: MatTable<PeriodicElement2>;
    delete: number;
    delete2: number;
    index: number = 0;
    index2: number = 0;

    objetosSelected: any;

    numeroPedimento: number = 0;
    nombre: string = '';
    tasa: number = 0;
    monto: number = 0;
    typo: string = '';
    mostrar = true;
    lstIva: any;
    lstIva_retenido: any;
    lstIeps: any;
    lstIsr: any;
    subscribeOperacion: any;
    idOperacion: number;
    ArrayImpuestosLocales = [];
    arreglo: any;
    a: any;
    lstDataReport = [];
    dataReport = [];
    idTipoReporteSel: number = 1;
    data: any;

    evento: any;
    idRoll = 2;
    mostrarControl = false;
    mostrarAddProducto = false;

    displayedColumns: string[] = [
        'position',
        'nombre',
        'tasa',
        'monto',
        'typo',
    ];
    dataSource1 = [{ position: '', nombre: '', tasa: 0, monto: 0, typo: '' }];

    displayedColumns2: string[] = ['position', 'nombre'];
    dataSource2 = [{ position: 0, numero_Pedimento: 0 }];

    mostrarAddCarga = false;
    contadorCargaMasiva = 0;
    lstTipoImpuesto: any;
    opcionSeleccionado = '';
    datosEventProducto: any;
    lstProducto: any = [];
    tituloFile;
    arrayBuffer: any;
    spinner: boolean = false;
    dataActualizacion: any = [];
    modificarDatos: boolean = false;
    rowsetshowClave: boolean = false;
    rowsetshowUnidad: boolean = false;
    mostrarIvaRet: boolean = false;
    errorNaN: boolean = false;
    isValidUnidad: boolean = true;
    isValidClave: boolean = true;
    idProducto: number;
    modeBtn: number;
    lstObjetoImpuesto: any;
    valObjetoImpuesto: boolean = true;
    nuevoProducto: any;
    cuentaPredial: any;
    ctaPredial: any = [];
    pedimentosArray: any = [];
    localesArray: any = [];
    claveSAT: any = { eje: '2' };
    productoMod: any;
    unidad_Medida: any;
    flagIep: any;
    catClaveSat: any;
    descripcionClaveSat: any;
    loadCatalogoClaveSat: boolean = false;
    // idEmpresa: any;

    constructor(
        private fb: FormBuilder,
        public dialog: MatDialog,
        private readonly store: Store<AppState>,
        private srvcoal: CoalService,
        private _snackBar: MatSnackBar,
        private renderer: Renderer2,
        public dialogRef: MatDialogRef<ProductoAddComponent>,
        @Inject(MAT_DIALOG_DATA) public dataProducto: any
    ) {
        this.numeroPedimentoForm = this.fb.group({
            numeroPedimentos: this.fb.array([]),
        });
        this.displayFn = this.displayFn.bind(this);
        this.displayFnUnidadMedida = this.displayFnUnidadMedida.bind(this);
    }

    ngOnInit(): void {
        // console.log("dataProducto", this.dataProducto);
        this.GetClaveSat();
        this.modeBtn = this.dataProducto.mode;
        if (this.dataProducto.mode == 2) {
            this.modificar(this.dataProducto.producto);
        }

        this.modificarDatos = false;
        this.dataSource1 = [];
        this.dataSource2 = [];

        this.GetCatalogoImpuestos();
        this.formProducto();
        this.productoForm.controls.iepsCuota.disable();

        this.myControl.disable();
        this.myControlUnidadMedida.disable();
        this.initForm();
    }

    EliminaProductoPorOperacion() {
        if (this.dataReport.length === 0)
            return this._snackBar.open('No hay registros que eliminar', 'Ok', {
                duration: 10000,
            });
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea eliminar este registro?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                //console.log(this.dataReport);
                let body = {
                    idOperacion: this.idOperacion,
                };
                this.srvcoal
                    .postService('catalogo/PostDelProductoPorOperacion', body)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                this._snackBar.open(
                                    res.recordsets[0][0].mensaje,
                                    'ok',
                                    { duration: 3000 }
                                );
                                this.mostrarAddCarga = false;
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                        }
                    );
            } else {
                this._snackBar.open('Eliminacion cancelada', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
            }
        });
    }

    DescargarPlantilla() {
        const workbook = new ExcelJS.Workbook();
        const general = workbook.addWorksheet('PlantillaProducto');
        let columnas = [
            'Codigo',
            'Nombre',
            'Descripcion',
            'Unidad',
            'Precio',
            'UnitCode',
            'CodeProdServ',
            'Agregado',
            'Errores',
        ];
        let headerRow = general.addRow(columnas);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D3D3D3' },
                bgColor: { argb: 'FF0000FF' },
            };
            cell.font = {
                size: 11,
                bold: true,
            };
        });
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
                new Blob([buffer], { type: 'application/octet-stream' }),
                'Plantilla Productos' + '-' + new Date().valueOf() + '.xlsx'
            );
        });
    }

    importExcel($event) {
        this.lstProducto = [];
        let file = ($event.target as HTMLInputElement).files[0];
        if (file === undefined) {
            this.tituloFile = 'Seleccione un archivo';
            this._snackBar.open(
                'Favor de seleccionar un archivo válido',
                'Ok',
                { duration: 10000 }
            );
            // this.spinner = false;
        } else {
            this.tituloFile = file.name;
            if (
                file.name.toLowerCase().indexOf('.xlsx') > 0 ||
                file.name.toLowerCase().indexOf('.xls') > 0
            ) {
                this.xlsxToJSON(file);
            } else {
                this._snackBar.open(
                    'Favor de seleccionar un archivo válido',
                    'Ok',
                    { duration: 10000 }
                );
                // this.spinner = false;
            }
        }
    }

    xlsxToJSON(event) {
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(event);
        fileReader.onload = async (e) => {
            this.arrayBuffer = fileReader.result;
            let data = new Uint8Array(this.arrayBuffer);
            let arr = new Array();
            for (let i = 0; i != data.length; ++i)
                arr[i] = String.fromCharCode(data[i]);
            let bstr = arr.join('');
            let workbook = XLSX.read(bstr, { type: 'binary' });
            let first_sheet_name = workbook.SheetNames[0];
            let worksheet = workbook.Sheets[first_sheet_name];
            let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
            this.lstProducto = arraylist;
            this.lstProducto.array.forEach((x) => {
                x.Nombre = x.Nombre.toUpperCase();
                x.Descripcion = x.Descripcion.toUpperCase();
            });
            this._snackBar.open('Carga de datos completa', 'Ok', {
                duration: 10000,
            });
            // this.spinner = false;
            //console.log('datos del excel', this.lstProducto)
        };
    }

    procesarArchivo() {
        if (this.lstProducto.length === 0)
            return this._snackBar.open('Favor de cargar un archivo', 'Ok', {
                duration: 10000,
            });
        let xmlProducto = `<propiedades>`;
        this.lstProducto.forEach((e) => {
            xmlProducto += `<propiedad><Codigo>${e.Codigo}</Codigo><Nombre>${e.Nombre}</Nombre><Descripcion>${e.Descripcion}</Descripcion><Unidad>${e.Unidad}</Unidad><Precio>${e.Precio}</Precio><UnitCode>${e.UnitCode}</UnitCode><CodeProdServ>${e.CodeProdServ}</CodeProdServ><Agregado>${e.Agregado}</Agregado><Errores>${e.Errores}</Errores></propiedad>`;
        });
        xmlProducto += `</propiedades>`;
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea registrar estos productos?',
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                //console.log(this.dataReport);
                let body = {
                    idRol: 2,
                    idOperacion: this.idOperacion,
                    XMLProductoTemplate: xmlProducto,
                };
                this.srvcoal
                    .postService('catalogo/PostINSProductoTemplate', body)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                this._snackBar.open(
                                    res.recordsets[0][0].mensaje,
                                    'ok',
                                    { duration: 3000 }
                                );
                                this.lstProducto.length = 0;
                                this.mostrarAddCarga = false;
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                        }
                    );
            } else {
                this._snackBar.open('Proceso cancelado', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
                this.lstProducto.length = 0;
            }
        });
    }

    imprimirNombre(event, index) {
        this.nombre = event.target.value;
        this.dataSource1[index].nombre = this.nombre;
        // console.log('nombre', this.nombre)
        // let nombre = (<HTMLInputElement>event.target).value
    }

    imprimirMonto(event, index) {
        // this.monto = event.target.value;
        // this.dataSource1[index].monto = Number(this.monto);
        const valorInput = event.target.value;
        if (/^\$?(\d+\.?\d*|\.\d+)$/.test(valorInput)) {
            const valorNumerico = +valorInput;
            const valorFormateado = valorNumerico.toFixed(2);
            event.target.value = valorFormateado;
            this.dataSource1[index].monto = parseFloat(valorFormateado);
        } else {
            // Si el valor no es válido, asignar el valor anterior o un valor predeterminado
            event.target.value = this.dataSource1[index].monto.toFixed(2);
            this.dataSource1[index].monto = parseFloat(this.dataSource1[index].monto.toFixed(2));
        }
    }

    imprimirTasa(event: any, index: number) {
        const valorInput = event.target.value;
        if (/^\$?(\d+\.?\d*|\.\d+)$/.test(valorInput)) {
            const valorNumerico = +valorInput;
            const valorFormateado = valorNumerico.toFixed(4);
            event.target.value = valorFormateado;
            this.dataSource1[index].tasa = parseFloat(valorFormateado);
        } else {
            event.target.value = '0.0000';
            this.dataSource1[index].tasa = 0;
        }
    }

    imprimirTypo(event, index) {
        this.typo = event;
        this.dataSource1[index].typo = this.typo;
        //console.log('typo', this.typo)
    }

    addData() {
        this.dataSource1.push({
            position: '',
            nombre: '',
            tasa: 0,
            monto: 0,
            typo: '',
        });
        this.datosTabla1.renderRows();
    }

    removeData(index) {
        this.dataSource1.splice(index, 1);
        this.datosTabla1.renderRows();
        //console.log('data despues de eliminacion', this.dataSource1)
    }

    removeData2(index) {
        this.dataSource2.splice(index, 1);
        this.datosTabla2.renderRows();
    }

    btnClave() {
        window.open('http://200.57.3.89/PyS/catPyS.aspx', '_blank');
    }

    btnUnidad() {
        window.open('http://200.57.3.89/PyS/catUnidades.aspx', '_blank');
    }

    private _filter(value: string): ProductoServicio[] {
        const filterValue = value.toLowerCase();
        return this.options.filter((option) =>
            option.claveDescripcion.toLowerCase().includes(filterValue)
        );
    }

    displayFn(id: any): string {
        if (id && id.attributes) {
            const clave = id.attributes.clave || '';
            const descripcion = id.attributes.descripcion || '';
            return `${clave}-${descripcion}`;
        }
    }

    displayFnUnidadMedida(id: any): string {
        if (id && id.attributes) {
            const clave = id.attributes.clave || '';
            const descripcion = id.attributes.nombre || '';
            return `${clave}-${descripcion}`;
        }
    }
    private _filterUnidadMedida(value: string): UnidadMedida[] {
        const filterValueUnidad = value.toLowerCase();
        return this.unidadMedida.filter((option) =>
            option.claveNombre.toLowerCase().includes(filterValueUnidad)
        );
    }

    GetClaveSat(){
        this.loadCatalogoClaveSat = false;
        this.srvcoal
        .getService(
            `cat-claves-sat?pagination[start]=0&pagination[limit]=54000`
        )
        .subscribe(
            (res: any) => {
                // console.log(res);
                this.catClaveSat = res.data;
                this.loadCatalogoClaveSat = true;
                if (this.dataProducto.mode == 2) {
                    console.log('se cargo el catalogo y es modificacion');
                    this.GetSelProductoServicio( this.descripcionClaveSat, 1);
                }
            })
    }

    GetSelProductoServicio(event, accion) {
        const descripcion = accion === 0 ? event.target.value.trim() : event.trim();
    
        // Validar que se ingrese al menos 4 caracteres
        if (descripcion.length < 4) {
            this._snackBar.open(
                'Favor de ingresar al menos 4 caracteres',
                'OK',
                { duration: 5000 }
            );
            return false;
        }
    
        this.myControl.enable();
        this.store.dispatch(MostrarSpinner());
    
        if (descripcion) {
            // Realizar búsqueda local en this.catClaveSat
            try {
                this.options = this.catClaveSat.filter((item: any) => {
                    const clave = item.attributes.clave.toLowerCase();
                    const desc = item.attributes.descripcion.toLowerCase();
                    const query = descripcion.toLowerCase();
                    return clave.includes(query) || desc.includes(query);
                });
    
                if (this.options.length === 0) {
                    this._snackBar.open(
                        'No se encontraron resultados con tu búsqueda, favor de intentar nuevamente.',
                        'OK',
                        { duration: 5000 }
                    );
                } else {
                    this.claveSAT = this.options;
                    this.rowsetshowClave = true;
    
                    // Focalizar el input después de un pequeño retraso
                    setTimeout(() => {
                        const element = this.renderer.selectRootElement('#myInputClave');
                        element.focus();
                    }, 500);
                }
            } catch (error) {
                console.error('Error al filtrar los datos:', error);
                this._snackBar.open(
                    'Ocurrió un error al realizar la búsqueda.',
                    'OK',
                    { duration: 5000 }
                );
            } finally {
                this.store.dispatch(OcultarSpinner());
            }
        } else {
            this.store.dispatch(OcultarSpinner());
        }
    }
    

    GetSelProductoServicio1(event, accion) {
        const descripcion = accion === 0 ? event.target.value : event;
        if (descripcion.length < 4) {
            this._snackBar.open(
                'Favor de ingresar al menos 4 caracteres',
                'OK',
                { duration: 5000 }
            );
            return false;
        }
        this.myControl.enable();
        this.store.dispatch(MostrarSpinner());
        if (descripcion != null || descripcion != '') {
            this.srvcoal
                .getService(
                    `clave-sat/filter?descripcion=${descripcion}&pagination[start]=0&pagination[limit]=54000`
                )
                .subscribe(
                    (res: any) => {
                        accion !== 1
                            ? this.store.dispatch(OcultarSpinner())
                            : '';
                        if (res.err) {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: res.error,
                                    tipoExcepcion: 4,
                                })
                            );
                        } else if (res.excepcion) {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: res.excepcion,
                                    tipoExcepcion: 3,
                                })
                            );
                        } else {
                            this.options = res.data;
                            this.claveSAT = res.data;
                            if (this.options.length == 0) {
                                this._snackBar.open(
                                    'No se encontraron resultados con tu busqueda, favor de intentar nuevamente.',
                                    'OK',
                                    { duration: 5000 }
                                );
                            } else {
                                this.rowsetshowClave = true;
                                //myInputClave
                                setTimeout(() => {
                                    //this.myInputClave.nativeElement.focus();
                                    var element =
                                        this.renderer.selectRootElement(
                                            '#myInputClave'
                                        );
                                    element.focus();
                                }, 500);
                            }

                            ////console.log('servicio', this.options)
                        }
                    },
                    (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                    }
                );
        } else {
            this.store.dispatch(OcultarSpinner());
        }
    }
    GetSelUnidadMedia(event, accion) {
        const nombre = accion === 0 ? event.target.value : event;

        if (nombre.length < 2) {
            this._snackBar.open(
                'Favor de ingresar al menos 2 caracteres',
                'OK',
                { duration: 5000 }
            );

            return false;
        }

        this.myControlUnidadMedida.enable();
        this.store.dispatch(MostrarSpinner());
        if (nombre != null || nombre != '') {
            this.srvcoal
                .getService(
                    `cat-unidad/filter?nombre=${nombre}&pagination[start]=0&pagination[limit]=3000`
                )
                .subscribe(
                    (res: any) => {
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: res.error,
                                    tipoExcepcion: 4,
                                })
                            );
                        } else if (res.excepcion) {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: res.excepcion,
                                    tipoExcepcion: 3,
                                })
                            );
                        } else {
                            this.unidadMedida = res.data;
                            this.unidad_Medida = res.data;
                            if (this.unidadMedida.length == 0) {
                                this._snackBar.open(
                                    'No se encontraron resultados con tu busqueda, favor de intentar nuevamente.',
                                    'OK',
                                    { duration: 5000 }
                                );
                            } else {
                                this.rowsetshowUnidad = true;
                                setTimeout(() => {
                                    var element =
                                        this.renderer.selectRootElement(
                                            '#myInputUnidad'
                                        );
                                    element.focus();
                                }, 500);
                            }
                            ////console.log('unidad medida act', this.unidadMedida)
                        }
                    },
                    (error: any) => {
                        this.store.dispatch(OcultarSpinner());
                        this.store.dispatch(
                            MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                        );
                    }
                );
        } else {
            this.store.dispatch(OcultarSpinner());
        }
    }
    onUnidadMedidaSelected(event: MatAutocompleteSelectedEvent): void {
        // console.log("event.option.value",event.option.value)
        this.myControlUnidadMedida.setValue(event.option.value);
    }
    eraseUnidad() {
        this.rowsetshowUnidad = false;
        this.myControlUnidadMedida.reset();

        this.isValidUnidad = false;
        //this.myControlUnidadMedida.setValue('');

        setTimeout(() => {
            // this.myInputClave.nativeElement.focus();
            var element = this.renderer.selectRootElement(
                '#myInputBusquedaUnidad'
            );
            element.focus();
        }, 500);
    }

    eraseClaveSat() {
        this.rowsetshowClave = false;
        this.myControl.reset();

        this.isValidClave = false;
        //        this.myControl.setValue('');

        setTimeout(() => {
            // this.myInputClave.nativeElement.focus();
            var element = this.renderer.selectRootElement(
                '#myInputBusquedaClave'
            );
            element.focus();
        }, 500);
    }

    GetTasa(edit: number = 1) {
        let valor = this.productoForm.controls.tasa.value;
        // console.log("getTasa")
        if (valor === true) {
            this.productoForm.controls.cuota.setValue(false);
            this.productoForm.controls.iepsTasa.enable();
            if (edit == 1) {
                this.productoForm.controls.ivaRet.setValue(null);
                this.productoForm.controls.ivaRet.disable()
            }
            this.mostrar = true;
        } else {
            this.productoForm.controls.tasa.setValue(false);
            this.productoForm.controls.cuota.setValue(true);
            this.productoForm.controls.iepsTasa.disable();

            if (edit == 1) {
                this.productoForm.controls.iepsCuota.setValue('');
                this.mostrarIvaRet = false;
                this.productoForm.controls.ivaRet.setValue(null);
                this.productoForm.controls.ivaRet.disable()
            }
            this.mostrar = false;
        }
    }

    getCuota(edit: number = 1) {
        let valor = this.productoForm.controls.cuota.value;
        if (valor === true) {
            this.productoForm.controls.tasa.setValue(false);
            this.productoForm.controls.iepsCuota.enable();
            this.mostrar = false;
        } else {
            this.productoForm.controls.cuota.setValue(false);
            this.productoForm.controls.tasa.setValue(true);
            this.productoForm.controls.iepsCuota.disable();
            this.mostrar = true;
        }

        if (edit == 1) {
            this.productoForm.controls.iepsCuota.setValue('');
            this.mostrarIvaRet = false;
        }
    }

    onSearchChange(value: any) {
        if (Number.isNaN(parseFloat(value))) {
            if (value.toString().length == 0) {
                this.errorNaN = false;
            } else {
                this.errorNaN = true;
            }
        } else {
            if (value.toString().length == 0) {
                this.mostrarIvaRet = false;
            } else {
                if (value < 0) {
                    this.errorNaN = true;
                } else {
                    this.errorNaN = false;
                    this.mostrarIvaRet = true;
                    this.productoForm.controls.ivaRet.setValue(0);
                }
            }
        }
    }

    addProducto() {
        this.mostrarAddProducto = true;
        this.mostrarAddCarga = false;
    }

    cerrarAddProducto() {
        this.mostrarAddProducto = false;
        this.mostrarAddCarga = false;
        this.modificarDatos = false;
        this.productoForm.reset();
        this.dataSource1 = [];
        this.dataSource2 = [];
        this.myControl.reset();
        this.myControlUnidadMedida.reset();
        this.productoForm.controls.tasa.setValue(true);
        this.GetCatalogoImpuestos();
    }

    addCargaMasiva() {
        this.contadorCargaMasiva++;
        if (this.contadorCargaMasiva % 2) {
            //console.log('con ++', this.contadorCargaMasiva)
            this.mostrarAddCarga = true;
        } else {
            this.mostrarAddCarga = false;
        }
    }

    formProducto() {
        this.productoForm = this.fb.group({
            nomInterno: new FormControl('', Validators.required),
            noIdentificacion: new FormControl(),
            precioUnitario: new FormControl(0, [
                Validators.required,
                Validators.min(0),
            ]),
            cuentaPredial: new FormControl(),
            descripcion: new FormControl('', Validators.required),
            iva: new FormControl(),
            ivaRet: new FormControl(),
            tasa: new FormControl(true),
            cuota: new FormControl(),
            iepsCuota: new FormControl([
                Validators.pattern(/^\d+(\.\d{0,3})?$/),
            ]),
            iepsTasa: new FormControl(),
            isr: new FormControl(),
            ObjetoImpuesto: new FormControl(0, Validators.required),
            // claveProductoServicio : new FormControl('', Validators.required),
            // claveProductoUnidad : new FormControl('', Validators.required),
        });
    }

    GetCatalogoImpuestos() {
        this.store.dispatch(MostrarSpinner());
        this.GetIVA();
        this.GetIVARetenciones();
        this.GetIeps();
        this.GetIsr();
        this.GetTipoImpuesto();
        this.GetObjetoImpuesto();
    }

    GetIVA() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-ivas`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    console.log('erro *************** 1');
                } else {
                    this.lstIva = res.data;
                    if (this.dataProducto.mode == 1) {
                        let indexIva = this.lstIva.findIndex((x) => x.id === 1);
                        this.productoForm.controls.iva.setValue(
                            this.lstIva[indexIva].id
                        );
                    }
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                this.store.dispatch(OcultarSpinner());
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    GetIVARetenciones() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-iva-retenciones`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    // console.log("erro *************** 1")
                } else {
                    this.lstIva_retenido = res.data;
                    // console.log('IVAS retenidos', res.data)
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                this.store.dispatch(OcultarSpinner());
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    GetIeps() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-iepses`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    console.log('erro *************** 1');
                } else {
                    this.lstIeps = res.data;
                    // console.log('IEPS', res.data)
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                this.store.dispatch(OcultarSpinner());
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    GetIsr() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-isrs`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    console.log('erro *************** 1');
                } else {
                    this.lstIsr = res.data;
                    // console.log('ISR', res.data)
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                this.store.dispatch(OcultarSpinner());
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    GetTipoImpuesto() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-tipo-impuestos`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    console.log('erro *************** 1');
                } else {
                    this.lstTipoImpuesto = res.data;
                    // console.log('tipo impuesto', res.data)
                    this.store.dispatch(OcultarSpinner());
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    GetObjetoImpuesto() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-objeto-impuestos`).subscribe(
            (res: any) => {
                ////this.store.dispatch(OcultarSpinner());;
                if (res.err) {
                    // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    console.log('erro *************** 1');
                } else {
                    this.lstObjetoImpuesto = res.data;
                    // console.log('tipo impuesto', res.data)
                    this.store.dispatch(OcultarSpinner());
                }
            },
            (error: any) => {
                console.log('erro *************** 3', error);
                this.store.dispatch(OcultarSpinner());
                // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                // this.spinner = false;
            }
        );
    }
    newCuentaPredial(body) {
        return this.srvcoal.postService(`pro-cuentas-predial`, body);
    }

    newPedimento(body) {
        return this.srvcoal.postService(`pro-pedimentos`, body);
    }
    newImpuestoLocal(body) {
        return this.srvcoal.postService(`pro-impuestos-locales`, body);
    }

    insertProducto() {
        try {
            // console.log('this.dataSource1', this.dataSource1);
            this.productoForm.markAllAsTouched();
            this.productoForm.updateValueAndValidity();

            this.myControlUnidadMedida.markAllAsTouched();

            this.myControl.markAllAsTouched();

            this.isValidClave = this.myControl.valid;
            this.isValidUnidad = this.myControlUnidadMedida.valid;

            this.valObjetoImpuesto = !this.productoForm.controls.ObjetoImpuesto
                .value
                ? false
                : true;
            console.log("valObjetoImpuesto", this.productoForm.value)
            if( this.productoForm.controls.ObjetoImpuesto.value == 2 ){
                if((this.productoForm.controls.iva == null || Number(this.productoForm.controls.iva.value) == 0) 
                    && (this.productoForm.controls.ivaRet == null || Number(this.productoForm.controls.ivaRet.value) == 0)
                    && (this.productoForm.controls.iepsTasa == null || Number(this.productoForm.controls.iepsTasa.value) == 0)
                    && (this.productoForm.controls.isr == null || Number(this.productoForm.controls.isr.value) == 0)
                ){
                    console.log('No se ha elegido ningun impuesto');
                    return this._snackBar.open(
                        'Al elegir "02 - Si objeto de impuestos" se debera especificar los impuestos que aplicara.',
                        'OK',
                        { duration: 5000 }
                    );
                }
            }

            // return false;
            if (!this.productoForm.valid)
                return this._snackBar.open(
                    'Favor de completar los datos requeridos',
                    'OK',
                    { duration: 5000 }
                );
            if (!this.myControlUnidadMedida.valid)
                return this._snackBar.open(
                    'Favor de asignar una unidad',
                    'OK',
                    { duration: 5000 }
                );
            if (!this.myControl.valid)
                return this._snackBar.open(
                    'Favor de asignar una clave SAT',
                    'OK',
                    { duration: 5000 }
                );

            if (
                this.cuentasPrediales.value.length > 0 &&
                !this.cuentasPrediales.valid
            ) {
                return this._snackBar.open(
                    'Falta completar datos en cuenta predial, o bien, puede eliminar las filas que no desee registrar',
                    'Ok',
                    { duration: 10000 }
                );
            }
            if (
                this.numeroPedimentos.value.length > 0 &&
                !this.numeroPedimentoForm.get('numeroPedimentos').valid
            ) {
                return this._snackBar.open(
                    'Falta completar datos en pedimentos, o bien, puede eliminar las filas que no desee registrar',
                    'Ok',
                    { duration: 10000 }
                );
            }

            const completoImpuestos = this.dataSource1.filter((x) => {
                const esNumeroPositivo = (valor: any) =>
                    typeof valor === 'number'; //&& valor > 0;

                return (
                    x.nombre === '' ||
                    (esNumeroPositivo(x.tasa) && !esNumeroPositivo(x.monto)) ||
                    (!esNumeroPositivo(x.tasa) && esNumeroPositivo(x.monto)) ||
                    x.typo === ''
                );
            });

            if (completoImpuestos.length > 0)
                return this._snackBar.open(
                    'Falta completar datos en impuestos locales, o bien, puede eliminar las filas que no desee registrar',
                    'Ok',
                    { duration: 10000 }
                );

            const validarTasa = this.dataSource1.filter((x) => x.tasa > 0.9999);
            if (validarTasa.length > 0)
                return this._snackBar.open(
                    'La tasa no debe ser mayor a 0.9999, favor de verificar',
                    'Ok',
                    { duration: 10000 }
                );

            if (this.productoForm.controls.ObjetoImpuesto.value === 0) {
                return this._snackBar.open(
                    'El campo Objeto Impuesto es requerido.',
                    'OK',
                    { duration: 5000 }
                );
            }

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '350px',
                data: '¿Desea continuar con el proceso de registro?',
            });
            dialogRef.afterClosed().subscribe(async (result) => {
                if (result) {
                    this.store.dispatch(MostrarSpinner());
                    // console.log("this.dataSource1",this.dataSource1)
                    const cuentaPredialObservables =
                        this.cuentaPredialForm.value.cuentasPrediales.map(
                            (cuenta: any) => {
                                const cuentaPredial = {
                                    data: {
                                        cuentaPredial:
                                            cuenta.numeroCuentaPredial,
                                    },
                                };
                                return this.newCuentaPredial(cuentaPredial);
                            }
                        );

                    const pedimentoObservables =
                        this.numeroPedimentoForm.value.numeroPedimentos.map(
                            (pedimento: any) => {
                                const pedimentoIns = {
                                    data: {
                                        pedimento: pedimento.numeroPedimento,
                                    },
                                };
                                return this.newPedimento(pedimentoIns);
                            }
                        );
                    const localesObservables = this.dataSource1.map(
                        (local: any) => {
                            const localesIns = {
                                data: {
                                    nombre: local.nombre,
                                    tasa: local.tasa,
                                    monto: local.monto,
                                    cat_tipo_impuesto: { id: local.typo },
                                },
                            };
                            return this.newImpuestoLocal(localesIns);
                        }
                    );

                    const resultados = await forkJoin([
                        ...cuentaPredialObservables,
                        ...pedimentoObservables,
                        ...localesObservables,
                    ]).toPromise();
                    // console.log("resultados.length",resultados)
                    if (resultados && resultados.length > 0) {
                        // console.log("resultados.length",resultados)
                        resultados.forEach((res: any) => {
                            if (res.err) {
                                console.log('Error ***************');
                            } else {
                                if (res.data.attributes.cuentaPredial) {
                                    this.ctaPredial.push({
                                        id: res.data.id,
                                    });
                                } else if (res.data.attributes.pedimento) {
                                    this.pedimentosArray.push({
                                        id: res.data.id,
                                    });
                                } else if (res.data.attributes.nombre) {
                                    this.localesArray.push({
                                        id: res.data.id,
                                    });
                                }
                            }
                        });
                    }
                    //console.log('this.ctaPredial', this.ctaPredial);
                    //   console.log('this.dataSource1', this.dataSource1);
                    // console.log('Resultados de todas las llamadas:', resultados);
                    // console.log("else",this.numeroPedimentoForm.value.numeroPedimentos)
                    let body = {
                        data: {
                            nombre: this.productoForm.controls.nomInterno.value,
                            noIdentificacion:
                                this.productoForm.controls.noIdentificacion
                                    .value,
                            descripcion:
                                this.productoForm.controls.descripcion.value,
                            precioUnitario: parseFloat(
                                this.productoForm.controls.precioUnitario.value
                            ),
                            cuentaPredial:
                                this.productoForm.controls.cuentaPredial.value,
                            esTasa: this.productoForm.controls.cuota.value
                                ? false
                                : true,
                            cat_iva:
                                this.productoForm.controls.iva.value === null || Number(this.productoForm.controls.iva.value) === 0
                                    ? null
                                    : {
                                        id: this.productoForm.controls.iva
                                            .value,
                                    },
                            cat_iva_ret: this.productoForm.controls.ivaRet.value === null || Number(this.productoForm.controls.ivaRet.value) === 0
                                ? null
                                : {
                                    id: this.productoForm.controls.ivaRet.value,
                                },
                            cat_iep:
                                this.productoForm.controls.iepsTasa.value === null || Number(this.productoForm.controls.iepsTasa.value) === 0
                                    ? null
                                    : {
                                        id: this.productoForm.controls
                                            .iepsTasa.value,
                                    },
                            cat_isr:
                                this.productoForm.controls.isr.value === null || Number(this.productoForm.controls.isr.value) === 0
                                    ? null
                                    : {
                                        id: this.productoForm.controls.isr
                                            .value,
                                    },
                            cat_unidad: {
                                id: this.myControlUnidadMedida.value.id,
                            },
                            cat_objeto_impuesto: {
                                id: this.productoForm.controls.ObjetoImpuesto
                                    .value,
                            },
                            cat_clave_sat: {
                                id: this.myControl.value.id,
                            },
                            pro_cuenta_predials: this.ctaPredial,
                            pro_pedimentos: this.pedimentosArray,
                            pro_impuesto_locals: this.localesArray,
                            cuotaIeps: this.productoForm.controls.cuota.value
                                ? Number(this.productoForm.controls.iepsCuota.value) === 0 ? null : this.productoForm.controls.iepsCuota.value
                                : null,
                            ope_empresa: this.dataProducto.idEmpresa,
                        },
                    };
                    // console.log('body Productos:', body)

                    this.srvcoal.postService(`pro-productos`, body).subscribe(
                        (res: any) => {
                            this.store.dispatch(OcultarSpinner());
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                var resp = res.data;
                                this._snackBar.open(
                                    'Nuevo producto agregado con exito',
                                    'OK',
                                    { duration: 12000 }
                                );
                                // console.log("insert", resp)

                                this.productoForm.reset();
                                this.dataSource1 = [];
                                this.dataSource2 = [];
                                this.cerrarAddProducto();
                                this.myControl.reset();
                                this.myControlUnidadMedida.reset();

                                this.idProducto = res.data.attributes.data.id; //resp.id;
                                this.getProductoId(this.idProducto);
                                //this.getCliente(res.data.id)
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                        }
                    );
                } else {
                    this._snackBar.open('Registro cancelado', 'OK', {
                        duration: 3000,
                    });
                    this.store.dispatch(OcultarSpinner());
                }
            });
        } catch (error) {
            console.error('Error al ejecutar llamadas asíncronas:', error);
        }
    }
    getProductoId(id) {
        let idProducto = id;
        this.srvcoal
            .getService(
                `pro-productos?filters[id][$eq]=${idProducto}&populate[cat_clave_sat][populate]=*
        &populate[cat_iep][populate]=*
        &populate[cat_isr][populate]=*
        &populate[cat_iva][populate]=*
        &populate[cat_iva_ret][populate]=*
        &populate[cat_objeto_impuesto][populate]=*
        &populate[cat_unidad][populate]=*
        &populate[pro_cuenta_predials][populate]=*
        &populate[pro_pedimentos][populate]=*
        &populate[pro_impuesto_locals][populate]=*`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else {
                        // this._snackBar.open(
                        //     "ok",
                        //     'ok',
                        //     {
                        //         duration: 3000,
                        //     }
                        // );
                        this.nuevoProducto = res.data[0];
                        // console.log('resProducto', res);
                        this.dialogRef.close({
                            success: 1,
                            producto: this.nuevoProducto,
                        });
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({
                            pila: error,
                            tipoExcepcion: 2,
                        })
                    );
                    this.store.dispatch(OcultarSpinner());
                    this.spinner = false;
                }
            );
    }
    selecctionIeps(e) {
        if (e === 0) {
            this.productoForm.controls.ivaRet.enable();
        } else {
            this.productoForm.controls.ivaRet.setValue(null);
            this.productoForm.controls.ivaRet.disable();
        }
    }

    modificar(e) {
        // console.log("Modificar dialog", e);
        this.dataActualizacion = e;
        this.idProducto = e.id;
        this.addProducto();
        this.productoMod = e.attributes;
        //this.llenarFormProducto(e.attributes)
        setTimeout(() => this.llenarFormProducto(e.attributes), 500);
        this.modificarDatos = true;
    }

    llenarFormProducto(e) {
        // console.log("eeeee",e)
        this.productoForm.controls.nomInterno.setValue(e.nombre);
        this.productoForm.controls.noIdentificacion.setValue(
            e.noIdentificacion
        );
        this.productoForm.controls.precioUnitario.setValue(e.precioUnitario);
        this.productoForm.controls.cuentaPredial.setValue(
            e?.cuentaPredial?.data
        );
        this.productoForm.controls.descripcion.setValue(e.descripcion);
        this.productoForm.controls.iva.setValue(
            e.cat_iva.data ? e.cat_iva.data.id : null
        );
        if (e.cat_iva_ret.data !== null) {
            this.productoForm.controls.ivaRet.setValue(e?.cat_iva_ret?.data.id);
        } else {
            this.mostrarIvaRet = true;
        }

        if (e.esTasa) {
            this.flagIep = e.cat_iep.data ? 1 : 2;
            this.productoForm.controls.tasa.setValue(true);
            this.productoForm.controls.cuota.setValue(false);
            this.GetTasa(this.flagIep);
            this.productoForm.controls.iepsTasa.setValue(
                e.cat_iep.data ? e.cat_iep.data.id : null
            );

        } else {
            this.flagIep = e.cuotaIeps ? 1 : 2;
            this.productoForm.controls.tasa.setValue(false);
            this.productoForm.controls.cuota.setValue(true);
            this.GetTasa(this.flagIep);
            this.productoForm.controls.iepsCuota.enable();
            this.productoForm.controls.iepsCuota.setValue(
                e.cuotaIeps ? e.cuotaIeps : null
            );
        }

        this.productoForm.controls.isr.setValue(
            e.cat_isr.data ? e.cat_isr.data.id : null
        );
        this.descripcionClaveSat = e.cat_clave_sat.data.attributes.descripcion;
        // this.GetSelProductoServicio(
        //     e.cat_clave_sat.data.attributes.descripcion,
        //     1
        // );
        this.GetSelUnidadMedia(e.cat_unidad.data.attributes.nombre, 1);
        //setTimeout(() => this.cargarAutocomplete(e), 4500);
        this.cargarAutocomplete(e);
        this.productoForm.controls.ObjetoImpuesto.setValue(
            e.cat_objeto_impuesto.data.id
        );

        // LLenamos cuenta predial
        if (e.pro_cuenta_predials.data.length > 0) {
            let _cuentaPredial = e.pro_cuenta_predials.data; //JSON.parse( e.pro_cuenta_predials)
            _cuentaPredial.forEach((cp) => {
                const cuentaPredial = this.fb.group({
                    numeroCuentaPredial: [
                        cp.attributes.cuentaPredial,
                        [Validators.required, Validators.pattern(/^\d{9}$/)],
                    ],
                });
                this.cuentasPrediales.push(cuentaPredial);
            });
        }
        // LLenamos cuenta predial
        if (e.pro_pedimentos.data.length > 0) {
            let _pedimentos = e.pro_pedimentos.data; //JSON.parse( e.pro_cuenta_predials)
            _pedimentos.forEach((cp) => {
                const pedimentos = this.fb.group({
                    numeroPedimento: [
                        cp.attributes.pedimento,
                        [
                            Validators.required,
                            Validators.pattern(/^\d{2}\s\d{2}\s\d{4}\s\d{7}$/),
                        ],
                    ],
                });
                this.numeroPedimentos.push(pedimentos);
            });
        }
        // ******   IMPUESTO LOCALES *****
        if (e.pro_impuesto_locals.data.length > 0) {
            let _impuesto = e.pro_impuesto_locals.data;
            _impuesto.forEach((x, index) => {
                const impuesto = {
                    position: index,
                    nombre: x.attributes.nombre,
                    tasa: x.attributes.tasa,
                    monto: x.attributes.monto,
                    typo: x.attributes.cat_tipo_impuesto.data.id,
                };
                this.dataSource1.push(impuesto);
            });
            this.datosTabla1.renderRows();
        }
    }

    cargarAutocomplete(e) {
        // console.log("cargarAutocomplete",e)
        this.myControl.setValue(e.cat_clave_sat.data);
        this.myControlUnidadMedida.setValue(e.cat_unidad.data);
    }

    ActualizarProducto() {
        this.valObjetoImpuesto = !this.productoForm.controls.ObjetoImpuesto
            .value
            ? false
            : true;

        if (!this.productoForm.valid)
            return this._snackBar.open(
                'Favor de completar los datos requeridos',
                'OK',
                { duration: 5000 }
            );
        // const completoPedimento = this.dataSource2.filter(x => x.numero_Pedimento === 0);
        // if (completoPedimento.length > 0)
        //     return this._snackBar.open('Falta completar datos en pedimento, o bien, puede eliminar las filas que no desee registrar', 'Ok', { duration: 10000 });
        // ********
        if (
            this.cuentasPrediales.value.length > 0 &&
            !this.cuentasPrediales.valid
        ) {
            return this._snackBar.open(
                'Falta completar datos en cuenta predial, o bien, puede eliminar las filas que no desee registrar',
                'Ok',
                { duration: 10000 }
            );
        }
        if (
            this.numeroPedimentos.value.length > 0 &&
            !this.numeroPedimentos.valid
        ) {
            //!this.numeroPedimentoForm.get('numeroPedimentos').valid){
            return this._snackBar.open(
                'Falta completar datos en pedimentos, o bien, puede eliminar las filas que no desee registrar',
                'Ok',
                { duration: 10000 }
            );
        }

        // const completoImpuestos = this.dataSource1.filter(x => x.nombre === '' || x.tasa === 0 || x.monto < 0 || x.typo === '')
        // if (completoImpuestos.length > 0)
        //     return this._snackBar.open('Falta completar datos en impuestos locales, o bien, puede eliminar las filas que no desee registrar', 'Ok', { duration: 10000 });
        const completoImpuestos = this.dataSource1.filter((x) => {
            const esNumeroPositivo = (valor: any) =>
                typeof valor === 'number' && valor > 0;

            return (
                x.nombre === '' ||
                !esNumeroPositivo(x.tasa) ||
                !esNumeroPositivo(x.monto) ||
                x.typo === ''
            );
        });

        if (completoImpuestos.length > 0)
            return this._snackBar.open(
                'Falta completar datos en impuestos locales, o bien, puede eliminar las filas que no desee registrar',
                'Ok',
                { duration: 10000 }
            );
        const validarTasa = this.dataSource1.filter(
            (x) => Number(x.tasa) > 0.9999
        );
        if (validarTasa.length > 0)
            return this._snackBar.open(
                'La tasa no debe ser mayor a 0.9999, favor de verificar',
                'Ok',
                { duration: 10000 }
            );

        if (this.productoForm.controls.ObjetoImpuesto.value === 0) {
            return this._snackBar.open(
                'El campo Objeto Impuesto es requerido.',
                'OK',
                { duration: 5000 }
            );
        }

        // ********************

        // ****

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '350px',
            data: '¿Desea continuar con el proceso de actualización?',
        });
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                this.store.dispatch(MostrarSpinner());
                const cuentaPredialObservables =
                    this.cuentaPredialForm.value.cuentasPrediales.map(
                        (cuenta: any) => {
                            const cuentaPredial = {
                                data: {
                                    cuentaPredial: cuenta.numeroCuentaPredial,
                                },
                            };
                            return this.newCuentaPredial(cuentaPredial);
                        }
                    );

                const pedimentoObservables =
                    this.numeroPedimentoForm.value.numeroPedimentos.map(
                        (pedimento: any) => {
                            const pedimentoIns = {
                                data: { pedimento: pedimento.numeroPedimento },
                            };
                            return this.newPedimento(pedimentoIns);
                        }
                    );
                const localesObservables = this.dataSource1.map(
                    (local: any) => {
                        const localesIns = {
                            data: {
                                nombre: local.nombre,
                                tasa: local.tasa,
                                monto: local.monto,
                                cat_tipo_impuesto: { id: local.typo },
                            },
                        };
                        return this.newImpuestoLocal(localesIns);
                    }
                );

                const resultados = await forkJoin([
                    ...cuentaPredialObservables,
                    ...pedimentoObservables,
                    ...localesObservables,
                ]).toPromise();
                
                // Procesar las respuestas y llenar los arrays
                if (resultados && resultados.length > 0) {
                    resultados.forEach((res: any) => {
                        if (res.err) {
                            console.error('Error al procesar:', res);
                        } else {
                            // Llenar arrays según las respuestas del backend
                            if (res.data.attributes.cuentaPredial) {
                                this.ctaPredial.push({
                                    id: res.data.id,
                                });
                            } else if (res.data.attributes.pedimento) {
                                this.pedimentosArray.push({
                                    id: res.data.id,
                                });
                            } else if (res.data.attributes.nombre) {
                                this.localesArray.push({
                                    id: res.data.id,
                                });
                            }
                        }
                    });
                }
                
                // Imprimir los resultados para depuración
                console.log('Cuentas prediales:', this.ctaPredial);
                console.log('Pedimentos:', this.pedimentosArray);
                console.log('Impuestos locales:', this.localesArray);
                
                // Validar que, si hay datos para registrar en cuentas prediales, estos se hayan registrado correctamente
                if (this.cuentaPredialForm.value.cuentasPrediales.length > 0 && this.ctaPredial.length === 0) {
                    return this._snackBar.open(
                        'Error: No se pudieron registrar las cuentas prediales. Por favor, intente de nuevo.',
                        'Ok',
                        { duration: 5000 }
                    );
                }

                console.log(this.ctaPredial);
                

                let producto = {
                    data: {
                        nombre: this.productoForm.controls.nomInterno.value,
                        noIdentificacion:
                            this.productoForm.controls.noIdentificacion.value,
                        descripcion:
                            this.productoForm.controls.descripcion.value,
                        precioUnitario: parseFloat(
                            this.productoForm.controls.precioUnitario.value
                        ),
                        cuentaPredial:
                            this.productoForm.controls.cuentaPredial.value,
                        esTasa: this.productoForm.controls.cuota.value
                            ? false
                            : true,
                        cat_iva:
                            this.productoForm.controls.iva.value === null || Number(this.productoForm.controls.iva.value) === 0
                                ? null
                                : {
                                    id: this.productoForm.controls.iva.value,
                                },
                        cat_iva_ret: this.productoForm.controls.ivaRet.value === null || Number(this.productoForm.controls.ivaRet.value) === 0
                            ? null
                            : {
                                id: this.productoForm.controls.ivaRet.value
                            },
                        cat_iep:
                            this.productoForm.controls.iepsTasa.value === null || Number(this.productoForm.controls.iepsTasa.value) === 0
                                ? null
                                : {
                                    id: this.productoForm.controls.iepsTasa
                                        .value,
                                },
                        cat_isr:
                            this.productoForm.controls.isr.value === null || Number(this.productoForm.controls.isr.value) === 0
                                ? null
                                : {
                                    id: this.productoForm.controls.isr.value,
                                },
                        cat_unidad: {
                            id: this.myControlUnidadMedida.value.id,
                        },
                        cat_objeto_impuesto: {
                            id: this.productoForm.controls.ObjetoImpuesto.value,
                        },
                        cat_clave_sat: {
                            id: this.myControl.value.id,
                        },
                        pro_cuenta_predials: this.ctaPredial,
                        pro_pedimentos: this.pedimentosArray,
                        pro_impuesto_locals: this.localesArray,
                        cuotaIeps: this.productoForm.controls.cuota.value
                            ? Number(this.productoForm.controls.iepsCuota.value) === 0 ? null : this.productoForm.controls.iepsCuota.value
                            : null,
                    },
                };
                this.srvcoal
                    .putService(`pro-productos/${this.idProducto}`, producto)
                    .subscribe(
                        (res: any) => {
                            if (res.err) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.error,
                                        tipoExcepcion: 4,
                                    })
                                );
                            } else if (res.excepcion) {
                                this.store.dispatch(
                                    MostrarExcepcion({
                                        pila: res.excepcion,
                                        tipoExcepcion: 3,
                                    })
                                );
                            } else {
                                var resp = res.data;
                                // if (resp.success === 1) {
                                //     this._snackBar.open(resp.mensaje, 'OK', { duration: 3000 });
                                this.store.dispatch(OcultarSpinner());
                                // } else {
                                this._snackBar.open(
                                    'Modificado con exito',
                                    'OK',
                                    { duration: 3000 }
                                );
                                // }
                                // console.log("MODIFICACION",resp)
                                this.store.dispatch(OcultarSpinner());
                                this.productoForm.reset();
                                this.dataSource1 = [];
                                this.dataSource2 = [];
                                this.myControl.reset();
                                this.myControlUnidadMedida.reset();
                                this.cerrarAddProducto();
                                this.idProducto = resp.id;
                                this.getProductoId(this.idProducto);
                            }
                        },
                        (error: any) => {
                            this.store.dispatch(
                                MostrarExcepcion({
                                    pila: error,
                                    tipoExcepcion: 2,
                                })
                            );
                            this.store.dispatch(OcultarSpinner());
                        }
                    );
            } else {
                this._snackBar.open('Registro cancelado', 'OK', {
                    duration: 3000,
                });
                this.store.dispatch(OcultarSpinner());
            }
        });
    }

    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: 1,
                    idAplicacion: 1,
                    moduloExcepcion: 'sel-caja-historial.component',
                    mensajeExcepcion: '',
                    stack: pila,
                },
            });
            dialogRef.afterClosed().subscribe((result: any) => { });
        } catch (error) {
            // console.error(error);
        }
    }

    limitarNegativos(nuevoValor: any) {
        const valorComoCadena = nuevoValor != null ? nuevoValor.toString() : '';
        const valorSinFormato = valorComoCadena.replace(/[^\d.]/g, '');
        const valorCortado = valorSinFormato.slice(0, 18);

        if (valorCortado !== this.productoForm.get('precioUnitario').value) {
            this.productoForm.get('precioUnitario').setValue(valorCortado);
        }
    }


    onNoClick() {
        this.dialogRef.close({ success: 0, idProducto: 0 });
    }

    //#region Numero de Pedimento
    numeroPedimentoForm: FormGroup;
    get numeroPedimentos() {
        return this.numeroPedimentoForm.get('numeroPedimentos') as FormArray;
    }

    agregarNumeroPedimento() {
        //                 /^\d{2} \d{2} \d{4} \d{7}$
        //                 /^\d{2} \d{2} \d{4} \d{7}$
        const numeroPedimento = this.fb.group({
            numeroPedimento: [
                '',
                [
                    Validators.required,
                    Validators.pattern(/^\d{2}\s\d{2}\s\d{4}\s\d{7}$/),
                    Validators.minLength(18),
                    Validators.maxLength(18),
                ],
            ],
        });
        this.numeroPedimentos.push(numeroPedimento);
    }

    eliminarNumeroPedimento(index: number) {
        this.numeroPedimentos.removeAt(index);
    }

    imprimirNumeroPedimento(event: any) {
        // console.log(event.target.value);
        const nuevaCuenta = event.target.value.trim();
        if (nuevaCuenta.length === 18) {
            const existeDuplicado = this.numeroPedimentos.value
                .slice(0, -1)
                .some(control => control.numeroPedimento.trim() === nuevaCuenta);
            if (existeDuplicado) {
                this._snackBar.open('El número de pedimento ya existe', 'OK', {
                    duration: 3000,
                });
                this.numeroPedimentos.removeAt(this.numeroPedimentos.length - 1);
            }
        }
    }
    //#endregion

    //#region Cuenta predial
    cuentaPredialForm: FormGroup;
    initForm() {
        this.cuentaPredialForm = this.fb.group({
            cuentasPrediales: this.fb.array([]),
        });
    }

    get cuentasPrediales() {
        return this.cuentaPredialForm.get('cuentasPrediales') as FormArray;
    }

    agregarCuentaPredial() {
        const cuentaPredial = this.fb.group({
            numeroCuentaPredial: [
                '',
                [Validators.required, Validators.pattern(/^\d{9}$/), Validators.maxLength(9), Validators.minLength(9)],
            ],
        });
        this.cuentasPrediales.push(cuentaPredial);
    }

    eliminarCuentaPredial(index: number) {
        this.cuentasPrediales.removeAt(index);
    }

    imprimirCuentaPredial(event: any) {
        const nuevaCuenta = event.target.value.trim();
        if (nuevaCuenta.length === 9) {
            const existeDuplicado = this.cuentasPrediales.value
                .slice(0, -1)
                .some(control => control.numeroCuentaPredial.trim() === nuevaCuenta);

            if (existeDuplicado) {
                this._snackBar.open('La cuenta predial ya existe', 'OK', {
                    duration: 3000,
                });
                this.cuentasPrediales.removeAt(this.cuentasPrediales.length - 1);
            }
        }
    }



    //#endregion
}
